import apis from './config';

const articleTypeApi = apis.articleTypes;

export const fetchArticleTypes = async () => {
    try {
        const response = await articleTypeApi.get('/', {
            headers: { Accept: 'application/json' },
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching article types:', error);
        throw error;
    }
};
